import { Box, Button } from '@mui/material'
import { styles } from './styles'
import type { ControlProps } from './types'

export const AccrodionControl = (props: ControlProps) => {
  const { children, color = 'primary', ...rest } = props
  return (
    <Box sx={{ ...styles.root, ...styles.root[color] }} {...rest}>
      <Box sx={{ ...styles.in }}>{children}</Box>
    </Box>
  )
}
